import { gql } from '@apollo/client'
import { dispatchMutationGQL } from '../../gqlActions'
import { IContactSalesInput } from 'src/interface'

const SAVE_CONTACT_SALES = gql`
  mutation SaveContactSales($contactSales: ContactSalesInput!) {
    saveContactSales(contactSales: $contactSales) {
      comments
      country
      email
      formSource
      name
      organization
      phone
      state
      stullerAccount
    }
  }
`

/**
 * Save contact us data to contactSales Dynamo table.
 * @param data - An object containing all form values.
 * @returns status code
 */
export const saveContactSalesGQL = async (data: IContactSalesInput) => {
  return await dispatchMutationGQL({
    mutation: SAVE_CONTACT_SALES,
    variables: {
      contactSales: data
    },
    key: 'contactSales'
  })
}
